import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
import { useTheme } from 'emotion-theming';
import {
    searchResultLinkCSS,
    searchResultLinkCustomerCategoryCSS,
    searchResultLinkFamilyCategoryCSS,
    searchResultLinkPlatformCategoryCSS,
} from './styles/SearchResultLink.styles';
import PageGroupType from './PageGroupType';
import getTagCharacterForSearchLink from '../services/getTagCharacterForSearchLink';

export default function SearchResultLink({ category, className, label, searchWords, url }) {
    const theme = useTheme();
    const tagStyling = [
        category === PageGroupType.CUSTOMER && searchResultLinkCustomerCategoryCSS(theme),
        category === PageGroupType.FAMILY && searchResultLinkFamilyCategoryCSS(theme),
        category === PageGroupType.PLATFORM && searchResultLinkPlatformCategoryCSS(theme),
    ];

    return (
        <Link className={className} css={searchResultLinkCSS} to={url}>
            <span css={tagStyling}>{getTagCharacterForSearchLink(category)}</span>
            <Highlighter
                searchWords={searchWords ?? []}
                highlightTag="strong"
                autoEscape
                textToHighlight={label}
            />
        </Link>
    );
}

SearchResultLink.propTypes = {
    category: PropTypes.oneOf(Object.values(PageGroupType)),
    className: PropTypes.string,
    label: PropTypes.string.isRequired,
    searchWords: PropTypes.arrayOf(PropTypes.string),
    url: PropTypes.string,
};
